import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Explore Careers at ShipSkis',
  description:
    "We're changing the way skiers and boarders travel - and having a lot of fun doing it. " +
    'Check out open roles at ShipSkis, and find your next great opportunity.',
  alternates: {
    canonical: 'https://www.shipskis.com/careers',
  },
}

export default metadata
